<template>
  <home-layout>
    <div class="container-fluid  bg_principal" >
      <div class="container-fluid bg">
        <div class="container-fluid">
          <div class="row">
            <div class="bg-white form_login col-md-5 col-lg-4 col-xl-4 center-block">
              <p class="txt-invertir">Ingresa a tus inversiones</p>
              <form @submit.prevent="validateForm" id="frmlogin" name="frmlogin" class="needs-validation text-center" novalidate>
                <div class="form-group mt-3">
                  <input type="email" v-model="loginForm.identifier" class="form-control input-acces" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Email address" required>
                </div>
                <div class="form-group mt-4">
                  <input type="password" v-model="loginForm.password" class="form-control input-acces" id="exampleInputPassword1" placeholder="Password" required>
                </div>
                <div v-if="showError" class="txt_error_frm">{{messageErrorLogin}}</div>
                <button type="submit" class="btn-access">Entrar</button>
              </form>
              <p class="txt-aprende">Aprende m&aacute;s <a href="/blog" class="txt-aprende-aqui">aquí</a> </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <header-info :section=false :isLogin=true></header-info>
    <footer-info :section=false></footer-info>
  </home-layout>
  
</template>

<script>



import imgBackground from "@/assets/access/background.png";
import {getLogin, setLogin} from '@/services/auth'
import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import "@/assets/access.css";

export default {
  name: 'Access',
  props: {

  },
  data () {
    
    return {
      imgBackground:imgBackground,
      access:true,
      showError:false,
      messageErrorLogin:'',
      loginForm: {
        identifier:'',
        password:''
      }
    }
  }
  ,
  created () {
    document.body.classList.add("bg_principal");
  },
  mounted () {
    
  },
  components: {
    HeaderInfo,
    HomeLayout,
    FooterInfo
  },
  methods: {
    validateForm (event) {
      this.isValid = true
      const form = document.getElementById('frmlogin')
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
        form.classList.add('was-validated')
        this.isValid=false
      }

      if (this.isValid) {
          getLogin(this.loginForm).then((response) => {
            if (response.error) {
              if (response.error.name === 'ValidationError') {
                this.showData = false
                this.showError = true
                this.messageErrorLogin = "Invalid password or email, try again"
              } else if (response.data.message === 'PASS') {
                this.showData = false
                this.showError = true
                this.messageErrorLogin = 'La contraseña que has introducido es incorrecta. ¿Has olvidado la contraseña?'
              }
            } else {
              console.log("valido", response.data)
              this.isValid = true
              this.$session.start()
              
              let token = response.data.jwt
              this.$session.set('name', response.data.user.name)
              this.$session.set('lastname', response.data.user.lastname)
              //localStorage.setItem('name', response.data.user.name)
              //localStorage.setItem('lastname', response.data.user.lastname)
              //setLogin(token)
              //isAuthenticated()
              this.$session.set('session', token)
              //this.$router.push({name: 'Home'})
              window.location.href = '/home'
            }
      })
      }
      else {
        console.log("NO valido")
      }

    }
  }
}

</script>
